module.exports = __webpack_public_path__ + "static/media/fullEmployment.4823f10c.png";